import { Component, OnInit, ViewChild,Output, EventEmitter, Inject } from "@angular/core";
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { PeerReviewService } from 'src/app/Service/peerReview/peer-review.service';
import { IProjectElementDetailsOutput, PrjScpSerStgOutput, MemberECDMDOutput, ProjectAllDetailsOutput, PeerElementDetailsOutput, PeerAllElementDetailsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { PeerRequestInput, PeerReqDocElementsInput, PeerReqPrjElementsInput, PresenterDetailsInput, PeerRequestOutput } from 'src/app/ViewModel/PeerReviewModel';
import { CommonService } from 'src/app/Service/Common.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DatePipe, Time } from "@angular/common";
import { FormBuilder, FormGroup, FormControl, Validators } from "@angular/forms";
import { GridComponent } from "@progress/kendo-angular-grid";
import { NotificationService } from "src/app/Service/notification.service";
import { FileListComponent } from "src/app/CommonComponents/file-list/file-list.component";
import { FileService, FileUploadLibrary } from "src/app/Service/file/file.service";
import { FileUploadComponent } from "src/app/CommonComponents/file-upload/file-upload.component";
import { IMsgAttachmentsModel, IMsgDocumentAttachmentModel } from "src/app/ViewModel/CommunicationModel";
import { I } from "@angular/cdk/keycodes";
import { orderBy } from "lodash";


@Component({
  selector: 'app-review-creation',
  templateUrl: './review-creation.component.html',
  styleUrls: ['./review-creation.component.css']
})
export class ReviewCreationComponent implements OnInit {

  private userMappedObjFromDB = new Map<string, boolean>();
  projectId!: number;
  groupId!: number;
  memberId!: number;
  projectCode!: string;
  projectName!: string;
  projectDetails: any = [];
  PeerAllElementDetails!: PeerAllElementDetailsOutput;
  memberECD: MemberECDMDOutput[] = [];
  PeerScpSerStg: PrjScpSerStgOutput[] = [];
  reviewType: PeerElementDetailsOutput[] = [];
  scopeReview: PeerElementDetailsOutput[] = [];
  reqDocs: PeerElementDetailsOutput[] = [];
  typeOfstrc: PeerElementDetailsOutput[] = [];
  serviceList: PeerElementDetailsOutput[] = [];
  stagesList: PeerElementDetailsOutput[] = [];
  naturejob: PeerElementDetailsOutput[] = [];
  contracttyp: PeerElementDetailsOutput[] = [];
  peerProjectdetails: ProjectAllDetailsOutput[] = [];
  categoryAddList: any = [];
  public docdatevalue:any = new Date();
  public todaydate: Date = new Date(this.getDateFormat());
  public submissionDatedefault: Date = new Date(this.getDateFormat());
  public dateLOIdefault:Date = new Date(this.getDateFormat());
  isvideoconference: boolean = false;
  public isDocDateInvalid!: boolean;
  public isSubDateInvalid!: boolean;
  public isDateLOIinvalid!: boolean;
  projectForm!: FormGroup;
  reviewForm!: FormGroup;
  presenterForm!: FormGroup;
  startdate!: Date;
  enddate!: Date;
  isValidated: boolean = false;
  ecdmem: MemberECDMDOutput[] = [];
  mecdmem: MemberECDMDOutput[] = [];
  decdmem: MemberECDMDOutput[] = [];
  selectedReviewtype: PeerReqDocElementsInput[] = [];
  selectedStagetype: PeerReqDocElementsInput[] = [];
  //selectedScope: any[] = [];
  //selectedReqDoc: any[] = [];
  //selectedtypStruc: any[] = [];
  selectedServices: any[] = [];
  //selectedServicesforgrid: any[] = [];
  acceptFileTypes: string = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  selectedServicesforgridchk: any[] = [];
  selectednatureJob: PeerReqPrjElementsInput[] = [];
  selectedcontractTyp: PeerReqPrjElementsInput[] = [];
  reviewdedElements: PeerReqDocElementsInput[] = [];
  projectdedElements: PeerReqPrjElementsInput[] = [];
  presenterDetails: PresenterDetailsInput[] = [];
  selectedOption: string = 'general';
  selectednaturejob: string;
  selectedcontracttyp: string;
  checksubmit: boolean = false;
  public enableFullscreen:boolean =false;
  isProjectOverViewAvailable:boolean = false;
  isPRAdequacyCheckListAvailable:boolean = false;
  //attachmentsList: IMsgDocumentAttachmentModel[] = [];
  sessionList = [{
    "deD_Id":1,
    "deD_Description" : 'FN'
  },{
    "deD_Id":2,
    "deD_Description" : 'AN'
  }]
  lastCrNo:number=0;
  lastIrNo:number=0;
  uniqueCheckListId:number;
  // selectedTime: string = '';

  @ViewChild(GridComponent) public distGrid!: GridComponent;
  constructor(public _dialogRef: MatDialogRef<ReviewCreationComponent>,
    public _datepipe: DatePipe,
    private _formBuilder: FormBuilder,
    private _projInfoService: ProjectInfoService,
    private _commonService: CommonService,
    public datepipe: DatePipe,
    private peerreviewservice: PeerReviewService,
    private _notificationService: NotificationService,
    private dialog: MatDialog,
    private _fileService: FileService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.createReviewForm();
  }

  ngOnInit() {
    if(this.data)
    {
      this.lastCrNo=this.data.maxCr;
      this.lastIrNo=this.data.maxIr;
    }
    this.projectId = this._commonService.getProjectId();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.memberId = this._commonService.getLoggedInUserId();
    this.getAllPeerElementData();
    this.getProjectOverViewFile('0');
  }

  closeDialog() {
    this._dialogRef.close();
  }

  createReviewForm() {
    this.reviewForm = this._formBuilder.group({
      reviewType: new FormControl('', [Validators.required]),
      stagetype: new FormControl('', [Validators.required]),
      isvideoconference: new FormControl(false),
      time_from: new FormControl('', [Validators.required]),
      time_to: new FormControl('', [Validators.required]),
      //ScopeOfReview: new FormControl(this.selectedScope,[Validators.required]),
      ServiceIncluded: new FormControl(this.selectedServices,[Validators.required]),
      //RequiredDoc: new FormControl(this.selectedReqDoc,[Validators.required]),
      //typeOfStructure: new FormControl(this.selectedtypStruc,[Validators.required]),
      //otherScope: new FormControl(''),
      //otherService: new FormControl(''),
      doc_location: new FormControl('', [Validators.required])
    });

    // this.projectForm = this._formBuilder.group({
    //   project_Name: new FormControl(''),
    //   project_Code: new FormControl(''),
    //   buildingType: new FormControl(''),
    //   clientName: new FormControl(''),
    //   projectValue: new FormControl(''),
    //   designFees: new FormControl(''),
    //   projectBrief: new FormControl(''),
    //   scopeOfwork: new FormControl(''),
    //   buildArea: new FormControl(''),
    //   siteArea: new FormControl(''),
    //   proofConsultant: new FormControl(''),
    //   architectureConsultant: new FormControl(''),
    //   structureConsultant: new FormControl(''),
    //   consultantAppointed: new FormControl(''),
    //   scope_for_peer: new FormControl(''),
    //   edms_availability: new FormControl(false),
    //   divisionName: new FormControl(''),
    //   segHead: new FormControl(''), 
    // });

  }

  private getFormValue(form: FormGroup, formControlName: string): any {
    return form.get(formControlName)?.value;
  }

  public getAllPeerElementData() {
    this._projInfoService.getAllPeerElements({
      intProjectID: this.projectId,
      intGroupID: this.groupId,
      intUID: this.memberId
    })
      .subscribe((res: PeerAllElementDetailsOutput) => {
        if (res) {
          this.PeerAllElementDetails = res;
          this.PeerScpSerStg = this.PeerAllElementDetails.proscpserstg;
          this.memberECD = this.PeerAllElementDetails.memberEcdMD;
          this.reviewType = this.PeerScpSerStg.filter(x => x.dE_Id == 500);
          this.scopeReview = this.PeerScpSerStg.filter(x => x.dE_Id == 508);
          this.reqDocs = this.PeerScpSerStg.filter(x => x.dE_Id == 511);
          this.typeOfstrc = this.PeerScpSerStg.filter(x => x.dE_Id == 512);
          this.serviceList = this.PeerScpSerStg.filter(x => x.dE_Id == 8);
          this.stagesList = orderBy(this.PeerScpSerStg.filter(x => x.dE_Id == 510),['sort_By','deD_Id']);
          this.contracttyp = this.PeerScpSerStg.filter(x => x.dE_Id == 502);
          this.naturejob = this.PeerScpSerStg.filter(x => x.dE_Id == 501);
          this.ecdmem = this.memberECD.filter(x => x.short_desc == "ECD");
          this.mecdmem = this.memberECD.filter(x => x.short_desc == "MECD");
          this.decdmem = this.memberECD.filter(x => x.short_desc == "DECD");

          this.getpeerProjectdetails();
        }
      }, err => { });
  }

  start_end_date!: string;
  buildingbool:boolean = false;
  clientbool: boolean = false;
  buildingtypebool: boolean = false;
  prjvaluebool: boolean = false;
  designbool: boolean = false;
  prjbriefbool: boolean = false;
  buildAreabool: boolean = false;
  siteAreabool: boolean = false;
  proofConsultantbool: boolean = false;
  archConsultantbool: boolean = false;
  structConsultantbool: boolean = false;
  submissionDatebool: boolean = false;
  dateLOIbool: boolean = false;
  divbool: boolean = false;
  segbool: boolean = false;

  public getpeerProjectdetails() {
    this._projInfoService.getPeerProjectDetails({
      intProjectID: this.projectId,
      intUID: this.memberId
    })
      .subscribe((res: ProjectAllDetailsOutput[]) => {
        if (res) {
          this.peerProjectdetails = res;
          this.buildingbool = this.peerProjectdetails[0].building_type?true:false;
          this.clientbool = this.peerProjectdetails[0].client?true:false;
          this.buildingtypebool = this.peerProjectdetails[0].building_type?true:false;
          this.prjvaluebool = this.peerProjectdetails[0].project_value_in_lakhs?true:false;
          this.designbool = this.peerProjectdetails[0].design_fee_in_lakhs?true:false;
          this.divbool = this.peerProjectdetails[0].division_name?true:false;
          this.segbool = this.peerProjectdetails[0].seg_head?true:false;
          this.projectForm.get('project_Name')?.setValue(this.peerProjectdetails[0].project_description);
          this.projectForm.get('project_Code')?.setValue(this.peerProjectdetails[0].project_code);
          this.projectForm.get('buildingType')?.setValue(this.peerProjectdetails[0].building_type);
          this.projectForm.get('clientName')?.setValue(this.peerProjectdetails[0].client);
          this.projectForm.get('projectValue')?.setValue(this.peerProjectdetails[0].project_value_in_lakhs);
          this.projectForm.get('designFees')?.setValue(this.peerProjectdetails[0].design_fee_in_lakhs);
          this.projectForm.get('divisionName')?.setValue(this.peerProjectdetails[0].division_name);
          this.projectForm.get('segHead')?.setValue(this.peerProjectdetails[0].seg_head);
          this.prjbriefbool = this.peerProjectdetails[0].project_brief_description?true:false;
          this.projectForm.get('projectBrief')?.setValue(this.peerProjectdetails[0].project_brief_description);
          this.projectForm.get('scopeOfwork')?.setValue(this.peerProjectdetails[0].scope_of_work);
          this.proofConsultantbool = this.peerProjectdetails[0].proof_consultant_name?true:false;
          this.projectForm.get('proofConsultant')?.setValue(this.peerProjectdetails[0].proof_consultant_name);
          this.archConsultantbool= this.peerProjectdetails[0].architectural_consultant_name?true:false;
          this.projectForm.get('architectureConsultant')?.setValue(this.peerProjectdetails[0].architectural_consultant_name);
          this.structConsultantbool = this.peerProjectdetails[0].structural_consultant_name?true:false;
          this.projectForm.get('structureConsultant')?.setValue(this.peerProjectdetails[0].structural_consultant_name);
          this.siteAreabool = this.peerProjectdetails[0].site_area?true:false;
          this.projectForm.get('buildArea')?.setValue(this.peerProjectdetails[0].site_area);
          this.buildAreabool = this.peerProjectdetails[0].built_up_area?true:false;
          this.projectForm.get('siteArea')?.setValue(this.peerProjectdetails[0].built_up_area);
          this.projectForm.get('scope_for_peer')?.setValue(this.peerProjectdetails[0].scope_of_peer_review);
          if (this.peerProjectdetails[0].is_edms_available == "Y") {
            this.projectForm.get('edms_availability')?.setValue(true);
          }
          else {
            this.projectForm.get('edms_availability')?.setValue(false);
          }
          this.selectednaturejob = this.naturejob.filter(x => x.deD_Id == this.peerProjectdetails[0].dpJ_NOP_DED_ID)[0].deD_Description;
          this.selectedcontracttyp = this.contracttyp.filter(x => x.deD_Id == this.peerProjectdetails[0].dpJ_Contract_Type_DED_ID)[0].deD_Description;
          if (this.peerProjectdetails[0].submission_date_of_project && new Date(this.peerProjectdetails[0].submission_date_of_project)>=new Date()) {
            this.submissionDatedefault = new Date(this.peerProjectdetails[0].submission_date_of_project);
            this.submissionDatebool = true;
        }
          if (this.peerProjectdetails[0].date_of_LOI && new Date(this.peerProjectdetails[0].date_of_LOI)>=new Date()) {
            this.dateLOIdefault = new Date(this.peerProjectdetails[0].date_of_LOI);
            this.dateLOIbool = true;
          }
          if(this.peerProjectdetails[0].start_Date!=null && this.peerProjectdetails[0].end_Date!=null)
          {
            let startdate = this.datepipe.transform(this.peerProjectdetails[0].start_Date, "dd-MMM-yyyy");
            let enddate = this.datepipe.transform(this.peerProjectdetails[0].end_Date, "dd-MMM-yyyy");
            this.start_end_date = startdate + " to " + enddate;
          }
          else
          {
            this.start_end_date = "NULL";
          }
        }
      }, err => { });
  }

  fromTimeSelected(time: string): void {
    this.reviewForm.get('time_from').setValue(time.trim());
  }
  toTimeSelected(time: string): void {
  this.reviewForm.get('time_to').setValue(time.trim());
  }

  // isFromtimeInvalid : boolean = true;
  // isTotimeInvalid: boolean = true;
  // fromTime!:Time;
  // checkfromtime()
  // {
  //   let mintime :Time = {
  //     hours: 9,
  //     minutes: 0
  //   };
  //   let maxtime :Time = {
  //     hours: 17,
  //     minutes: 0
  //   };
  //   this.fromTime = this.getFormValue(this.reviewForm, 'time_from');
  //   let fromtime = this.getFormValue(this.reviewForm, 'time_from');
  //   let hr = fromtime.substr(0, 2);
  //   let min = fromtime.substr(3, 2);
  //   if(hr >= mintime.hours && hr <= maxtime.hours)
  //   {
  //     this.isFromtimeInvalid = false;
  //     return true;
  //   }
  //   else
  //   {
  //     this.isFromtimeInvalid = true;
  //     return false;
  //   }
  // }

  // checktotime()
  // {
  //   let fromtime = this.getFormValue(this.reviewForm, 'time_from');
  //   let from_hr = fromtime.substr(0, 2);
  //   let from_min = fromtime.substr(3, 2);
  //   let maxtime :Time = {
  //     hours: 17,
  //     minutes: 59
  //   };
    
  //   let totime = this.getFormValue(this.reviewForm, 'time_to');
  //   let hr = totime.substr(0, 2);
  //   let min = totime.substr(3, 2);
  //   if (hr >= from_hr && hr <= maxtime.hours) 
  //   {
  //     if(hr == from_hr)
  //     {
  //       if(min > from_min)
  //       {
  //         this.isTotimeInvalid = false;
  //         return true;
  //       }
  //       else
  //       {
  //         this.isTotimeInvalid = true;
  //         return false;
  //       }
  //     }
  //     else
  //     {
  //       this.isTotimeInvalid = false;
  //       return true;
  //     }
  //   } 
  //   else
  //   {
  //     this.isTotimeInvalid = true;
  //     return false;
  //   } 
  // }


  changeButtonToggle(event: { value: string; }) {
    this.selectedOption = event.value;
    if (this.selectedOption == 'peersubmit') {
      this.generalCreation();
    }
    else {
      this.selectedOption == 'general';
      this.isValidated = false;
    }
  }

  getDateFormat() {
    let today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = today.toLocaleString('default', { month: 'short' })
    var yyyy = today.getFullYear();
    let today1 = dd + '-' + mm + '-' + yyyy;
    return today1;
  }
  getDocDate(selectedText: { value: Date | null; }, field: string) 
  {
    if (field == 'Document Date') {
      this.isDocDateInvalid = selectedText.value == null;
      this.docdatevalue = selectedText.value;
    }
  }
  getSubmissionDate(selectedText: { value: Date | null; }, field: string) {
    if (field == 'Submission Date') {
      this.isSubDateInvalid = selectedText.value == null;
      this.submissionDatedefault = selectedText.value;
    }
  }
  getDateLoi(selectedText: { value: Date | null; }, field: string) {
    if (field == 'Date LOI') {
      this.isDateLOIinvalid = selectedText.value == null;
      this.dateLOIdefault = selectedText.value;
    }
  }

  selectedreviewtype(event: any) {
    this.selectedReviewtype = [];
    this.selectedReviewtype.push({ DE_ID: event.additionalValues.additionalValues.dE_Id, DED_ID: event.additionalValues.additionalValues.deD_Id, OTHERS_VALUE: "" });
  }

  selectedstagetype(event: any) {
    this.selectedStagetype = [];
    this.selectedStagetype.push({ DE_ID: event.additionalValues.additionalValues.dE_Id, DED_ID: event.additionalValues.additionalValues.deD_Id, OTHERS_VALUE: "" });
  }

  checkScope: boolean = false;
  checkServices : boolean = false;
  checkreqDoc: boolean = false;
  checktypStruc: boolean = false;


  // checkedReqDoc(event: any) 
  // {
  //   if (event && event.emittingList.length > 0) 
  //   {
  //     this.selectedReqDoc = this.selectedReqDoc.map(x => { x.is_checked = false; return x });
  //     for (let obj of event.emittingList) {

  //       let _data = this.selectedReqDoc.filter(x => { x.dED_Id == parseInt(obj.value) });
  //       let is_checked: boolean = this.selectedReqDoc.some(y => y.dED_ID == obj.additionalValues.deD_Id);
  //       if (!is_checked) {
  //         this.selectedReqDoc.push({ dE_ID: obj.additionalValues.dE_Id, dED_ID: obj.additionalValues.deD_Id, is_checked: true, other_value:"" });
  //       }
  //       else {
  //         this.selectedReqDoc.filter(x => x.dED_ID == parseInt(obj.additionalValues.deD_Id))[0].is_checked = true;
  //       }

  //     }
  //     this.selectedReqDoc = this.selectedReqDoc.filter(c => c.is_checked == true);
  //     if (this.selectedReqDoc.length > 0) {
  //       this.selectedReqDoc.forEach((dataItem, rowIndex) => {
  //         this.distGrid.editRow(rowIndex);
  //       });
  //     }
  //     this.reviewForm.get('RequiredDoc').setValue(this.selectedReqDoc)
  //     this.reviewForm.get('RequiredDoc')?.markAsTouched();
  //     this.checkreqDoc = true;
  //   }
  //   else 
  //   {
  //     this.selectedReqDoc = [];
  //     this.reviewForm.get('RequiredDoc').setValue([])
  //     this.checkreqDoc = false;
  //   }
  // }

  // checkedTypOfStruc(event: any) 
  // {
  //   if (event && event.emittingList.length > 0) 
  //   {
  //     this.selectedtypStruc = this.selectedtypStruc.map(x => { x.is_checked = false; return x });
  //     for (let obj of event.emittingList) {

  //       let _data = this.selectedtypStruc.filter(x => { x.dED_Id == parseInt(obj.value) });
  //       let is_checked: boolean = this.selectedtypStruc.some(y => y.dED_ID == obj.additionalValues.deD_Id);
  //       if (!is_checked) {
  //         this.selectedtypStruc.push({ dE_ID: obj.additionalValues.dE_Id, dED_ID: obj.additionalValues.deD_Id, is_checked: true, other_value:"" });
  //       }
  //       else {
  //         this.selectedtypStruc.filter(x => x.dED_ID == parseInt(obj.additionalValues.deD_Id))[0].is_checked = true;
  //       }

  //     }
  //     this.selectedtypStruc = this.selectedtypStruc.filter(c => c.is_checked == true);
  //     if (this.selectedtypStruc.length > 0) {
  //       this.selectedtypStruc.forEach((dataItem, rowIndex) => {
  //         this.distGrid.editRow(rowIndex);
  //       });
  //     }
  //     this.reviewForm.get('typeOfStructure').setValue(this.selectedtypStruc)
  //     this.reviewForm.get('typeOfStructure')?.markAsTouched();
  //     this.checktypStruc = true;
  //   }
  //   else 
  //   {
  //     this.selectedtypStruc = [];
  //     this.reviewForm.get('typeOfStructure').setValue([]);
  //     this.checktypStruc = false;
  //   }
  // }



  // checkedScope(event: any) {
  //   if (event && event.emittingList.length > 0) 
  //   {
  //     this.selectedScope = this.selectedScope.map(x => { x.is_checked = false; return x });
  //     for (let obj of event.emittingList) {

  //       let _data = this.selectedScope.filter(x => { x.dED_Id == parseInt(obj.value) });
  //       let is_checked: boolean = this.selectedScope.some(y => y.dED_ID == obj.additionalValues.deD_Id);
  //       if (!is_checked) {
  //         this.selectedScope.push({ dE_ID: obj.additionalValues.dE_Id, dED_ID: obj.additionalValues.deD_Id, is_checked: true, other_value:"" });
  //       }
  //       else {
  //         this.selectedScope.filter(x => x.dED_ID == parseInt(obj.additionalValues.deD_Id))[0].is_checked = true;
  //       }

  //     }
  //     this.selectedScope = this.selectedScope.filter(c => c.is_checked == true);
  //     if (this.selectedScope.length > 0) {
  //       this.selectedScope.forEach((dataItem, rowIndex) => {
  //         this.distGrid.editRow(rowIndex);
  //       });
  //     }
  //     this.checkScope = true;
  //     this.reviewForm.get('ScopeOfReview').setValue(this.selectedScope)
  //     this.reviewForm.get('ScopeOfReview')?.markAsTouched();
  //     this.getotherscope();
  //   }
  //   else {
  //     this.selectedScope = [];
  //     this.reviewForm.get('ScopeOfReview').setValue([])
  //     this.checkScope = false;
  //   }
  // }

  checkedServices(event: any) {
    if (event && event.emittingList.length > 0) 
    {
      //this.selectedServicesforgrid = this.selectedServicesforgrid.map(x => { x.is_checked = false; return x });
      this.selectedServices = this.selectedServices.map(x => { x.is_checked = false; return x });
      for (let obj of event.emittingList) {

        let _data = this.serviceList.filter(x => { x.deD_Id == parseInt(obj.value) });
        let is_checked: boolean = this.selectedServices.some(y => y.dED_ID == obj.additionalValues.deD_Id);
        if (!is_checked) {
          this.selectedServices.push({ dE_ID: obj.additionalValues.dE_Id, dED_ID: obj.additionalValues.deD_Id, is_checked: true, other_value:"" });
          // this.selectedServicesforgrid.push({
          //   deD_Description: obj.additionalValues.deD_Description,
          //   dE_ID: obj.additionalValues.dE_Id,
          //   dED_ID: obj.additionalValues.deD_Id,
          //   presenter: null,
          //   mail_id: null,
          //   pfrom_time: null,
          //   pto_time: null,
          //   remarks: null,
          //   is_checked: true
          // });
        }
        else {
          this.selectedServices.filter(x => x.dED_ID == parseInt(obj.additionalValues.deD_Id))[0].is_checked = true;
          //this.selectedServicesforgrid.filter(x => x.dED_ID == parseInt(obj.additionalValues.deD_Id))[0].is_checked = true;
        }

      }
      //this.selectedServicesforgrid = this.selectedServicesforgrid.filter(c => c.is_checked == true);
      this.selectedServices = this.selectedServices.filter(d => d.is_checked == true);

      // if (this.selectedServicesforgrid.length > 0) {
      //   this.selectedServicesforgrid.forEach((dataItem, rowIndex) => {
      //     this.distGrid.editRow(rowIndex);
      //   });
      // }
      this.checkServices = true;
      this.reviewForm.get('ServiceIncluded').setValue(this.selectedServices)
      this.reviewForm.get('ServiceIncluded')?.markAsTouched();
      //this.getotherservice();
    }
    else {
      //this.selectedServicesforgrid = [];
      this.selectedServices = [];
      this.reviewForm.get('ServiceIncluded').setValue(this.selectedServices)
      this.checkServices = false;
    }
  }

  selectedNaturejob(event: any) {
    this.selectednatureJob = [];
    this.selectednatureJob.push({ DE_ID: event.additionalValues.additionalValues.dE_Id, DED_ID: event.additionalValues.additionalValues.deD_Id });
  }

  selectedContractTyp(event: any) {
    this.selectedcontractTyp = [];
    this.selectedcontractTyp.push({ DE_ID: event.additionalValues.additionalValues.dE_Id, DED_ID: event.additionalValues.additionalValues.deD_Id });
  }

  // getotherscope()
  // {
  //   let other_scp = this.getFormValue(this.reviewForm, 'otherScope');
  //   if(other_scp != null && other_scp!="")
  //   {
  //     if(this.selectedScope.some(x=> x.dED_ID == 0))
  //     {
  //       let index = this.selectedScope.indexOf((x: { dED_ID: number; })=> x.dED_ID == 0);
  //       this.selectedScope.splice(index,1);
  //     }
  //     this.selectedScope.push({ dE_ID: 508, dED_ID: 0, is_checked: true , other_value: this.getFormValue(this.reviewForm, 'otherScope')});
  //   }
  //   else
  //   {
  //     if(this.selectedScope.some(x=> x.dED_ID == 0))
  //     {
  //       let index = this.selectedScope.indexOf((x: { dED_ID: number; })=> x.dED_ID == 0);
  //       this.selectedScope.splice(index,1);
  //     }
  //   }
  // }
  // getotherservice()
  // {
  //   let other_ser = this.getFormValue(this.reviewForm, 'otherService');
  //   if(other_ser != null && other_ser!="")
  //   {
  //     if(this.selectedServices.some(x=> x.dED_ID == 0))
  //     {
  //       let index = this.selectedServices.indexOf((x: { dED_ID: number; })=> x.dED_ID == 0);
  //       this.selectedServices.splice(index,1);
  //     }
  //     if(this.selectedServicesforgrid.some(x=> x.dED_ID == 0))
  //     {
  //       let index = this.selectedServicesforgrid.indexOf((x: { dED_ID: number; })=> x.dED_ID == 0);
  //       this.selectedServicesforgrid.splice(index,1);
  //     }
  //     this.selectedServices.push({ dE_ID: 8, dED_ID: 0, is_checked: true , other_value: this.getFormValue(this.reviewForm, 'otherService')});
  //     this.selectedServicesforgrid.push({
  //       deD_Description: other_ser,
  //       dE_ID: 8,
  //       dED_ID: 0,
  //       presenter: null,
  //       mail_id: null,
  //       pfrom_time: null,
  //       pto_time: null,
  //       remarks: null,
  //       is_checked: true
  //     });
  //   }
  //   else
  //   {
  //     if(this.selectedServices.some(x=> x.dED_ID == 0))
  //     {
  //       let index = this.selectedServices.indexOf((x: { dED_ID: number; })=> x.dED_ID == 0);
  //       this.selectedServices.splice(index,1);
  //     }
  //     if(this.selectedServicesforgrid.some(x=> x.dED_ID == 0))
  //     {
  //       let index = this.selectedServicesforgrid.indexOf((x: { dED_ID: number; })=> x.dED_ID == 0);
  //       this.selectedServicesforgrid.splice(index,1);
  //     }
  //   }
  //   if (this.selectedServicesforgrid.length > 0) {
  //     this.selectedServicesforgrid.forEach((dataItem, rowIndex) => {
  //       this.distGrid.editRow(rowIndex);
  //     });
  //   }
  // }

  generalCreation() 
  {
    // if(!this.checkfromtime())
    // {
    //   this._notificationService.showPopup("Select From Time in between 9:00 to 18:00", "Warning");
    // }
    // else if(!this.checktotime())
    // {
    //   this._notificationService.showPopup("Select To Time above " + this.fromTime +" to 18:00", "Warning");
    // }
    // else
    // {
      // if (this.reviewForm.valid && this.selectedScope.length > 0 && this.selectedServices.length > 0 && this.checkScope && this.checkServices 
      //     && this.selectedReqDoc.length > 0 && this.selectedtypStruc.length > 0 && this.checkreqDoc && this.checktypStruc) 
      if (this.reviewForm.valid  && this.selectedServices.length > 0  && this.checkServices) 
      {
        this.selectedOption = 'peersubmit';
        this.isValidated = true;
        this.reviewdedElements = [];
        this.selectedReviewtype.forEach(x => {
          this.reviewdedElements.push({ DE_ID: x.DE_ID, DED_ID: x.DED_ID, OTHERS_VALUE: "" });
        });
        this.selectedStagetype.forEach(x => {
          this.reviewdedElements.push({ DE_ID: x.DE_ID, DED_ID: x.DED_ID, OTHERS_VALUE: "" });
        });
        // this.selectedScope.forEach(x => {
        //   this.reviewdedElements.push({ DE_ID: x.dE_ID, DED_ID: x.dED_ID, OTHERS_VALUE: x.other_value });
        // });
        this.selectedServices.forEach(x => {
          this.reviewdedElements.push({ DE_ID: x.dE_ID, DED_ID: x.dED_ID, OTHERS_VALUE: x.other_value });
        });
        // this.selectedReqDoc.forEach(x => {
        //   this.reviewdedElements.push({ DE_ID: x.dE_ID, DED_ID: x.dED_ID, OTHERS_VALUE: x.other_value });
        // });
        // this.selectedtypStruc.forEach(x => {
        //   this.reviewdedElements.push({ DE_ID: x.dE_ID, DED_ID: x.dED_ID, OTHERS_VALUE: x.other_value });
        // });
        this.peerSubmit();
      }
      else {
        this._notificationService.showPopup("Fill the mandatory fields", "Warning");
        this.formMarkAsTouched(this.reviewForm);
        this.selectedOption = 'general';
        this.isValidated = false;
      }
    // }
  }

  formMarkAsTouched(form: FormGroup) {
    if (!form.valid)
      Object.keys(form.controls).forEach(key => {
        form.get(key)?.markAsTouched();
      });
  }

  peerSubmit() {
    //if (this.projectForm.valid) {
      // for Project details elements
      // this.projectdedElements = [];
      // this.presenterDetails = [];
      // if (this.selectednaturejob) {
      //   this.projectdedElements.push({ DE_ID: this.peerProjectdetails[0].dpJ_NOP_DE_ID, DED_ID: this.peerProjectdetails[0].dpJ_NOP_DED_ID });
      // }
      // else {
      //   this.selectednatureJob.forEach(x => {
      //     this.projectdedElements.push({ DE_ID: x.DE_ID, DED_ID: x.DED_ID });
      //   });
      // }
      // if (this.selectedcontracttyp) {
      //   this.projectdedElements.push({ DE_ID: this.peerProjectdetails[0].dpJ_Contract_Type_DE_ID, DED_ID: this.peerProjectdetails[0].dpJ_Contract_Type_DED_ID });
      // }
      // else {
      //   this.selectedcontractTyp.forEach(x => {
      //     this.projectdedElements.push({ DE_ID: x.DE_ID, DED_ID: x.DED_ID });
      //   });
      // }
      // this.selectedServicesforgrid.forEach(x => {
      //   if (x.presenter == "")
      //     x.presenter = null;
      //   if (x.mail_id == "")
      //     x.mail_id = null;
      //   if (x.pfrom_time == "")
      //     x.pfrom_time = null;
      //   if (x.pto_time == "")
      //     x.pto_time = null;
      // });

      // this.selectedServicesforgrid.forEach(x => {
      //   let index = this.selectedServicesforgrid.indexOf(x);
      //   if (x.presenter != null && (x.pfrom_time == null || x.pto_time == null)) {
      //     this._notificationService.showToast("Fill Presentation Time", "Warning");
      //   }
      //   else if (x.pfrom_time != null && (x.presenter == null || x.pto_time == null)) {
      //     this._notificationService.showToast("Fill Presenter details completely", "Warning");
      //   }
      //   else if (x.pto_time != null && (x.presenter == null || x.pfrom_time == null)) {
      //     this._notificationService.showToast("Fill Presenter details completely", "Warning");
      //   }
      //   else if (x.presenter != null && x.pfrom_time != null && x.pto_time != null) {
      //     let p_mintime: Time = { hours:9, minutes:0 };
      //     let p_maxtime: Time = { hours:17, minutes:59 };
      //     let pf_time = x.pfrom_time;
      //     let pf_hr = pf_time.substr(0, 2);
      //     let pf_min = pf_time.substr(3, 2);
      //     let pt_time = x.pto_time;
      //     let pt_hr = pt_time.substr(0, 2);
      //     let pt_min = pt_time.substr(3, 2);
      //     // if(pf_hr >= p_mintime.hours && pf_hr <= p_maxtime.hours)
      //     // {
      //       // if(pt_hr>=pf_hr && pt_hr<=p_maxtime.hours)
      //       // {
      //         if(pt_hr==pf_hr)
      //         {
      //           // if(pt_min > pf_min)
      //           // {
      //             if(x.mail_id == null || x.mail_id=="")
      //             {
      //               this.presenterDetails.push({
      //                 DE_ID: x.dE_ID,
      //                 DED_ID: x.dED_ID,
      //                 Presenter_Name: x.presenter,
      //                 Presenter_Mail_Id: x.mail_id,
      //                 From_Time: x.pfrom_time,
      //                 Upto_Time: x.pto_time,
      //                 Remarks: x.remarks
      //               });
      //             }
      //             else
      //             {
      //               if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(x.mail_id))
      //               {
      //                 this.presenterDetails.push({
      //                   DE_ID: x.dE_ID,
      //                   DED_ID: x.dED_ID,
      //                   Presenter_Name: x.presenter,
      //                   Presenter_Mail_Id: x.mail_id,
      //                   From_Time: x.pfrom_time,
      //                   Upto_Time: x.pto_time,
      //                   Remarks: x.remarks
      //                 });
      //               }
      //               else
      //               {
      //                 this._notificationService.showPopup("Enter valid Mail ID for "+ x.presenter, "Warning");
      //               }
      //             }
      //           // }
      //           // else
      //           // {
      //           //   this._notificationService.showPopup("Select " + x.presenter + "'s Presentation time above " + pf_time + " to 18:00", "Warning");
      //           // }
      //         }
      //         else
      //         {
      //           if(x.mail_id == null || x.mail_id=="")
      //           {
      //             this.presenterDetails.push({
      //               DE_ID: x.dE_ID,
      //               DED_ID: x.dED_ID,
      //               Presenter_Name: x.presenter,
      //               Presenter_Mail_Id: x.mail_id,
      //               From_Time: x.pfrom_time,
      //               Upto_Time: x.pto_time,
      //               Remarks: x.remarks
      //             });
      //           }
      //           else
      //           {
      //             if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(x.mail_id))
      //             {
      //               this.presenterDetails.push({
      //                 DE_ID: x.dE_ID,
      //                 DED_ID: x.dED_ID,
      //                 Presenter_Name: x.presenter,
      //                 Presenter_Mail_Id: x.mail_id,
      //                 From_Time: x.pfrom_time,
      //                 Upto_Time: x.pto_time,
      //                 Remarks: x.remarks
      //               });
      //             }
      //             else
      //             {
      //               this._notificationService.showPopup("Enter valid Mail ID for "+ x.presenter, "Warning");
      //             }
      //           }
      //         }
      //       // }
      //       // else
      //       // {
      //       //   this._notificationService.showPopup("Select " + x.presenter + "'s Presentation time above " + pf_time + " to 18:00", "Warning");
      //       // }
      //     // }
      //     // else
      //     // {
      //     //   this._notificationService.showPopup("Select Presenter From Time in between 9:00 to 18:00", "Warning");
      //     // }
      //   }
      // });

      //this.selectedServicesforgrid = this.selectedServicesforgrid.filter(y => y.presenter != null || y.pfrom_time != null || y.pto_time != null);

      // let input: PeerRequestInput =
      // {
      //   intProjectID: this.projectId,
      //   intGroupID: this.groupId,
      //   strDocElements: JSON.stringify(this.reviewdedElements),
      //   dtScheduledOn: this.docdatevalue,
      //   tmScheduledFrom: this.getFormValue(this.reviewForm, 'time_from'),
      //   tmScheduledUpto: this.getFormValue(this.reviewForm, 'time_to'),
      //   chrVCRequired: this.getFormValue(this.reviewForm, 'isvideoconference') == true ? "Y" : "N",
      //   strECDName : this.memberECD.filter(x => x.short_desc == 'ECD')[0].stringAggList ? this.memberECD.filter(x => x.short_desc == 'ECD')[0].stringAggList : "",
      //   strMEPECDName	: this.memberECD.filter(x => x.short_desc == 'MECD')[0].stringAggList ? this.memberECD.filter(x => x.short_desc == 'MECD')[0].stringAggList : "",
      //   strDECDName: this.memberECD.filter(x => x.short_desc == 'DECD')[0].stringAggList ? this.memberECD.filter(x => x.short_desc == 'DECD')[0].stringAggList : "",
      //   strProjectElements: JSON.stringify(this.projectdedElements),
      //   strProjectLongDesc: this.getFormValue(this.projectForm, 'projectBrief'),
      //   strBuildingType: this.getFormValue(this.projectForm, 'buildingType'),
      //   // strClient: this.getFormValue(this.projectForm, 'clientName'),
      //   strClient: 'B&F',
      //   strScopeofWork: this.getFormValue(this.projectForm, 'scopeOfwork'),
      //   strBuiltupArea: this.getFormValue(this.projectForm, 'buildArea'),
      //   strSiteArea: this.getFormValue(this.projectForm, 'siteArea'),
      //   dtDateOfLOI: this.dateLOIdefault,
      //   mnyProjectValueInLakhs: this.getFormValue(this.projectForm, 'projectValue'),
      //   mnyDesignFeeInLakhs: this.getFormValue(this.projectForm, 'designFees'),
      //   strProofConsultantName: this.getFormValue(this.projectForm, 'proofConsultant'),
      //   strArchitecturalConsultantName: this.getFormValue(this.projectForm, 'architectureConsultant'),
      //   strStructuralConsultantName: this.getFormValue(this.projectForm, 'structureConsultant'),
      //   strOtherConultantName: this.getFormValue(this.projectForm, 'consultantAppointed'),
      //   dtmSubmissionDateOfProject: this.submissionDatedefault,
      //   chrIsEDMSAvailable: this.getFormValue(this.projectForm, 'edms_availability') == true ? "Y" : "N",
      //   strDivisionName: this.getFormValue(this.projectForm, 'divisionName'),
      //   strSegmentHead: this.getFormValue(this.projectForm, 'segHead'),
      //   strScopeOfPeerReview: this.getFormValue(this.projectForm, 'scope_for_peer'),
      //   strPresenterDetails: JSON.stringify(this.presenterDetails),
      //   strDocLocation: this.getFormValue(this.reviewForm, 'doc_location'),
      //   intUID: this.memberId,
      // };

      let input: PeerRequestInput =
      {
        intProjectID: this.projectId,
        intGroupID: this.groupId,
        strDocElements: JSON.stringify(this.reviewdedElements),
        dtScheduledOn: this.docdatevalue,
        tmScheduledFrom: this.getFormValue(this.reviewForm, 'time_from'),
        tmScheduledUpto: this.getFormValue(this.reviewForm, 'time_to'),
        chrVCRequired: this.getFormValue(this.reviewForm, 'isvideoconference') == true ? "Y" : "N",
        strECDName : this.memberECD.filter(x => x.short_desc == 'ECD')[0]?.stringAggList ? this.memberECD.filter(x => x.short_desc == 'ECD')[0].stringAggList : "",
        strMEPECDName	: this.memberECD.filter(x => x.short_desc == 'MECD')[0]?.stringAggList ? this.memberECD.filter(x => x.short_desc == 'MECD')[0].stringAggList : "",
        strDECDName: this.memberECD.filter(x => x.short_desc == 'DECD')[0]?.stringAggList ? this.memberECD.filter(x => x.short_desc == 'DECD')[0].stringAggList : "",
        strProjectElements: null, //JSON.stringify(this.projectdedElements),
        strProjectLongDesc:null, //this.getFormValue(this.projectForm, 'projectBrief'),
        strBuildingType:null, //this.getFormValue(this.projectForm, 'buildingType'),
        // strClient: this.getFormValue(this.projectForm, 'clientName'),
        strClient: null,//'B&F',
        strScopeofWork: null,//this.getFormValue(this.projectForm, 'scopeOfwork'),
        strBuiltupArea: null,//this.getFormValue(this.projectForm, 'buildArea'),
        strSiteArea: null,//this.getFormValue(this.projectForm, 'siteArea'),
        dtDateOfLOI: null,//this.dateLOIdefault,
        mnyProjectValueInLakhs: null,//this.getFormValue(this.projectForm, 'projectValue'),
        mnyDesignFeeInLakhs: null,//this.getFormValue(this.projectForm, 'designFees'),
        strProofConsultantName: null,//this.getFormValue(this.projectForm, 'proofConsultant'),
        strArchitecturalConsultantName:null,// this.getFormValue(this.projectForm, 'architectureConsultant'),
        strStructuralConsultantName:null,// this.getFormValue(this.projectForm, 'structureConsultant'),
        strOtherConultantName: null,//this.getFormValue(this.projectForm, 'consultantAppointed'),
        dtmSubmissionDateOfProject: null,//this.submissionDatedefault,
        chrIsEDMSAvailable: null,//this.getFormValue(this.projectForm, 'edms_availability') == true ? "Y" : "N",
        strDivisionName: null,//this.getFormValue(this.projectForm, 'divisionName'),
        strSegmentHead: null,//this.getFormValue(this.projectForm, 'segHead'),
        strScopeOfPeerReview: null,// this.getFormValue(this.projectForm, 'scope_for_peer'),
        strPresenterDetails: null,//JSON.stringify(this.presenterDetails),
        strDocLocation: this.getFormValue(this.reviewForm, 'doc_location'),
        intUID: this.memberId,
      };

      //if (this.selectedServicesforgrid.length == 0) {
        this.peerreviewservice.postpeerRequest(input).subscribe((res: PeerRequestOutput) => {
          let result: PeerRequestOutput = res;
          //let success:boolean =false;
          if(result)
          {
            if(result.strDocNo && result.strErrorMsg==null)
            {
              this._notificationService.showPopup(result.strOldDocNo + " Peer Request Submitted Successfully", "Success");
              //success=true;
            }
            else if(result.strErrorMsg=="Member's PSNo is not updated in Master. Please get it updated and then try.")
              this._notificationService.showToast("Member's PSNo is not updated in Master. Please get it updated and then try.", "Warning");
            else if (result.strDocNo && result.strErrorMsg=="Mail Not Sent")
            {
              this._notificationService.showToast("Peer Request Submitted Successfully, Failed To Send Mail", "Warning");
              //success=true;
            }    
            else
              this._notificationService.showToast("Peer Request Failed", "Error");
          }
          else
            { this._notificationService.showToast("Peer Request Failed", "Error"); }
          // if(success)
          // {
          //   let value:string[] = result.strOldDocNo.split('-');
          //   let peerDocno = value[1].substring(2,value[1].length);
          //   let id = this.projectId+peerDocno;
          //   this.UpdateReviewCheckList(Number(id));
          // }
         // else{
            this.closeDialog();
          //}
          
        }, err => { 
          console.log(err);
        });
     // }
      // else if (this.selectedServicesforgrid.length == this.presenterDetails.length) {
      //   this.peerreviewservice.postpeerRequest(input).subscribe((res: PeerRequestOutput) => {
      //     let result: PeerRequestOutput = res;
      //     if(result)
      //     {
      //       if(result.strDocNo && result.strErrorMsg==null)
      //         this._notificationService.showPopup(result.strOldDocNo + " Peer Request Submitted Successfully", "Success");
      //       else if(result.strErrorMsg=="Member's PSNo is not updated in Master. Please get it updated and then try.")
      //         this._notificationService.showToast("Member's PSNo is not updated in Master. Please get it updated and then try.", "Warning");
      //       else
      //         this._notificationService.showToast("Peer Request Failed", "Error");
      //     }
      //     else
      //       { this._notificationService.showToast("Peer Request Failed", "Error");  }        
      //     this.closeDialog();
      //   }, err => { });
      // }
    //}
    // else {
    //   this._notificationService.showToast("Fill the mandatory fields", "Warning");
    //   this.formMarkAsTouched(this.projectForm);
    // }
  }

  // bulkEdit(grid: { editRow: (arg0: number) => void; }) {
  //   if (this.selectedServicesforgrid.length > 0) {
  //     this.selectedServicesforgrid.forEach((dataItem, rowIndex) => {
  //       grid.editRow(rowIndex);
  //     });
  //   }
  // }

  bulkSave(grid) {}

  cancelRowData({ sender, rowIndex, dataItem }) {
    sender.closeRow(rowIndex);
  }

  // onValueChange(val: any, fieldName: string, dataItem: any) {
  //   this.selectedServicesforgrid.filter(item => item.deD_Description.toLocaleLowerCase() == dataItem.deD_Description.toLocaleLowerCase()).every(x => x[fieldName] = val.target.value);
  // }

  // fromGridTimeSelected(val: any, fieldName: string, dataItem: any) {
  //   this.selectedServicesforgrid.filter(item => item.deD_Description.toLocaleLowerCase() == dataItem.deD_Description.toLocaleLowerCase()).every(x => x[fieldName] = val);
  // }

  uploadProjectOverview()
  {
    let uniqueProjectId = '00'+this.projectId+'001';
    const dialog = this.dialog.open( FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '80%',
      data: { projectId: this.projectId, docId: uniqueProjectId, revisionNo: '0', moduleName: 'EDMS', libraryName: FileUploadLibrary.WorkflowDocument,
          createdBy: this.memberId, 
          documents: [{ value: uniqueProjectId, text: 'ProjectOverview', revisionNo: '0',  task_SNo: 0 }],
          isEditable: false,isEnableFullScreen:true },
    });

    dialog.afterClosed().subscribe(()=>{
      this.getProjectOverViewFile('0');
    })
  }

  uploadPeerReviewChecklist()
  {
    let uniqueProjectId;
    if(this.selectedReviewtype && this.selectedReviewtype.length<=0 )
    {
      this._notificationService.showToast("Please select the review type before uploading the checklist","Warning");
      return;
    }
    if(this.selectedReviewtype && this.selectedReviewtype.length>0 && this.selectedReviewtype[0].DE_ID==undefined)
    {
      this._notificationService.showToast("Please select the review type before uploading the checklist","Warning");
      return;
    }
    else
    {
      if(this.selectedReviewtype[0].DED_ID==1)
      {
        uniqueProjectId = this.projectId+(this.lastCrNo+1).toString();
      }
      else{
        uniqueProjectId = this.projectId+(this.lastIrNo+1).toString();
      }
    }
    this.uniqueCheckListId = Number(uniqueProjectId);
    const dialog = this.dialog.open( FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '80%',
      data: { projectId: this.projectId, docId: uniqueProjectId, revisionNo: '1', moduleName: 'EDMS', libraryName: FileUploadLibrary.WorkflowDocument,
          createdBy: this.memberId, 
          documents: [{ value: uniqueProjectId, text: 'prAdequacyCheckList', revisionNo: '1',  task_SNo: 0 }],
          isEditable: false,isEnableFullScreen:true },
    });
    // dialog.componentInstance.onUploadFinished.subscribe(res => {
    //   let fileName: string = res.fileName;
    //   let fileExtn: string = fileName.substring(fileName.lastIndexOf(".") + 1);
    //   this.attachmentsList.push({ fileId: -1, fileName: fileName.substring(0, fileName.lastIndexOf(".")), fileExtension: fileExtn, fileSize: res.fileSize });
    // });
    dialog.afterClosed().subscribe(()=>{
      this.getProjectOverViewFile('1');
    })

  }

  getProjectOverViewFile(revisionNo:string)
  {
    let uniqueProjectId = this.projectId+'001';
    if(revisionNo=='1')
    {
      uniqueProjectId = this.uniqueCheckListId.toString();
    }
    this._fileService.GetFiles({libraryNumber: FileUploadLibrary.WorkflowDocument, value: JSON.stringify(
      { projectId: this.projectId, docId: Number(uniqueProjectId), revisionNo: revisionNo })}).subscribe((res:any)=>{
        if(revisionNo=='0')
        {
          this.isProjectOverViewAvailable = res && res.length>0 ? true:false
        }
        if(revisionNo=='1')
        {
          this.isPRAdequacyCheckListAvailable = res && res.length>0 ? true:false;
        }
      })
  }

  viewFile(revisionNo:string)
  {
    let uniqueProjectId = this.projectId+'001';
    if(revisionNo=='1')
    {
      uniqueProjectId = this.uniqueCheckListId.toString();
    }
    let _dialog=this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary', 'w80'],
      data: {
        projectId: this.projectId, docId: uniqueProjectId, revisionNo: revisionNo, libraryName: FileUploadLibrary.WorkflowDocument,
        createdBy: this.memberId, isDeleteEnable: true
      },
    });
    _dialog.afterClosed().subscribe(()=>{
      this.getProjectOverViewFile(revisionNo);
    })
  }

  // UpdateReviewCheckList(id:number)
  // {
  //   if(this.attachmentsList && this.attachmentsList.length>0)
  //   {
  //     let attachedDoc: IMsgAttachmentsModel = { projectId: this.projectId, msgId: id, createdBy: this.memberId, messageDocuments: this.attachmentsList }
  //     this.peerreviewservice.UpdateReviewChecklist(attachedDoc).subscribe((res:any)=>{
  //       this.closeDialog();
  //     })
  //   }
  // }


  selectedSession(event:any)
  {
    if(event && event.emittingList)
    {
      if(event.emittingList.length==1)
      {
        if(event.emittingList[0].value==1)
        {
          this.fromTimeSelected('10:00');
          this.toTimeSelected('13:00');
        }
        else{
          this.fromTimeSelected('14:00');
          this.toTimeSelected('17:00');
        }
      }
      if(event.emittingList.length>1)
      {
        this.fromTimeSelected('10:00');
        this.toTimeSelected('17:00');
      }
    }
    else{
      this.fromTimeSelected(null);
      this.toTimeSelected(null);
    }

  }
}
